import React from 'react';

export enum LOCALE {
  CN = 'zh-CN',
  EN = 'en',
  JP = 'ja',
}

export interface AppShape {
  locale: LOCALE;
  prefixCls: string;
  getPrefixCls: (suffixCls: string, prefixCls?: string) => string;
}

export const AppContext = React.createContext<AppShape>({} as AppShape);

export const AppConsumer = AppContext.Consumer;
export const AppProvider = AppContext.Provider;
